
export function FormatDate (date) {
  return new Date(date).toString() !== 'Invalid Date' ? (new Date(date)).toLocaleDateString('en-GB') : undefined
}

export function FormatDateTime (date) {
  return new Date(date).toString() !== 'Invalid Date' ? (new Date(date)).toLocaleDateString('en-GB') + '  ' + (new Date(date)).toLocaleTimeString('th-TH') : undefined
}

export function ToISOString (date) {
  return new Date(date).toString() !== 'Invalid Date' ? new Date(date).toISOString('en-GB') : undefined
}

export function FormatTime (date) {
  return new Date(date).toString() !== 'Invalid Date' ? (new Date(date)).toLocaleTimeString('th-TH') : undefined
}

export function ExportFileName (filename) {
  var nowDate = new Date()
  var exportDate = nowDate.toISOString().replace(/-/g, '').split('T')[0]
  var exportHour = (nowDate.getHours() < 10 ? '0' : '') + nowDate.getHours()
  var exportMinute = (nowDate.getMinutes() < 10 ? '0' : '') + nowDate.getMinutes()
  var exportSeconds = (nowDate.getSeconds() < 10 ? '0' : '') + nowDate.getSeconds()
  var exportFileName = filename + '-' + exportDate + '_' + exportHour + exportMinute + exportSeconds + '.xls'
  return exportFileName
}
